import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { Home } from 'react-feather';
import { Link } from 'react-router-dom';

const NotFoundContainer = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  background: ${({ theme }) => theme.background};
`;

const Content = styled(motion.div)`
  text-align: center;
  max-width: 600px;
`;

const ErrorCode = styled(motion.h1)`
  font-size: ${({ theme }) => theme.sizes['7xl']};
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-weight: ${({ theme }) => theme.weights.bold};
  background: ${({ theme }) => theme.gradient};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-bottom: 1rem;
`;

const Title = styled(motion.h2)`
  font-size: ${({ theme }) => theme.sizes['2xl']};
  color: ${({ theme }) => theme.text};
  margin-bottom: 1.5rem;
  font-family: ${({ theme }) => theme.fonts.secondary};
`;

const Description = styled(motion.p)`
  color: ${({ theme }) => theme.textLight};
  margin-bottom: 2rem;
  font-family: ${({ theme }) => theme.fonts.primary};
  line-height: ${({ theme }) => theme.lineHeights.relaxed};
`;

const HomeButton = styled(motion.button)`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background: ${({ theme }) => theme.gradient};
  color: white;
  padding: 1rem 2rem;
  border: none;
  border-radius: 0.5rem;
  font-weight: ${({ theme }) => theme.weights.semibold};
  cursor: pointer;
  text-decoration: none;
  transition: ${({ theme }) => theme.transition};
  box-shadow: ${({ theme }) => theme.shadowMd};

  &:hover {
    transform: translateY(-2px);
    box-shadow: ${({ theme }) => theme.shadowLg};
  }
`;

const containerVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      staggerChildren: 0.2
    }
  }
};

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0
  }
};

const NotFound = () => {
  return (
    <NotFoundContainer>
      <Content
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        <ErrorCode variants={itemVariants}>404</ErrorCode>
        <Title variants={itemVariants}>Page Not Found</Title>
        <Description variants={itemVariants}>
          Oops! The page you're looking for seems to have wandered off into the digital void. 
          Let's get you back to familiar territory.
        </Description>
        <motion.div variants={itemVariants}>
          <Link to="/" style={{ textDecoration: 'none' }}>
            <HomeButton
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <Home size={20} />
              Back to Home
            </HomeButton>
          </Link>
        </motion.div>
      </Content>
    </NotFoundContainer>
  );
};

export default NotFound;